import React, { useEffect, useState, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import swal from "sweetalert";
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import { Row, Col, Card, Table, Modal, Button, Tab, Nav, Spinner } from "react-bootstrap";
import Moment from 'react-moment';
import "react-datepicker/dist/react-datepicker.css";
import LeaveCardView from "../Components/LeaveCardView";
import AddReportManual from '../Components/AddReportManual';
import RightSideModal from '../Components/RightModal';
import { getOwnLeaveCalenderListData, getLeaveTypeData, updateReportLeaveListData } from '../../../store/actions/LeaveAction';
import { updateReportDetails, generatedReportDetails, getreportDrillData, getPeportProgressData, getMultiplePeportProgressData, postReportClientApprovalData, postReportRemoveData, getFilterGeneratedReportData, addTimesheetManuallyReportData } from '../../../store/actions/TimeCardActions';
import { getSummaryConfigData } from '../../../store/actions/SystemDefaultActions';
import { getNoteData, addNoteData } from '../../../store/actions/TimeCaptureActions';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';
import GenerateTimeCard from "../Components/GenerateTimeCard";
import ReportGenerateTimeCard from "../Components/ReportGenerateTimeCard";
import MultiProgressReport from "../Components/MultiProgressReport";
import ProgressReport from "../Components/ProgressReport";
import ReactPaginate from "react-paginate";

const GeneratedReport = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [activeTab, setActiveTab] = useState(1);
    const [reportType, setReportType] = useState(null);
    const [cardList, setCardList] = useState([]);
    const [cardDetails, setCardDetails] = useState(null);
    const [cardNonList, setCardNonList] = useState([]);
    const [cardNonDetails, setCardNonDetails] = useState(null);
    const [addModal, setAddModal] = useState(false);
    const [timeModal, setTimeModal] = useState(false);
    const [saveModal, setSaveModal] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [weeklyOff, setWeeklyOff] = useState(false);
    const [isComment, setIsComment] = useState(false);
    const [userId, setUserId] = useState('');

    //note
    const [message, setMessage] = useState('');
    const [projectId, setProjectId] = useState(null);
    const [reportId, setReportId] = useState(null);
    const [status, setStatus] = useState(null);
    const [noteData, setNoteData] = useState([]);
    const [isNote, setIsNote] = useState(false);
    const [loading, setLoading] = useState(false);
    const [appLoading, setAppLoading] = useState(false);
    const [details, setDetails] = useState(null);
    const [captureType, setCaptureType] = useState('0');
    const [reportFilterLoading, setReportFilterLoading] = useState(false);
    const [manualModal, setManualModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditIndex, setIsEditIndex] = useState(null);
    const [calenderDate, setCalenderDate] = useState(null);
    const [isText, setIsText] = useState(false);
    const [itemDetails, setItemDetails] = useState('');
    const [personalDetails, setPersonalDetails] = useState([]);
    const [multipleLegends, setMultipleLegends] = useState([]);
    //Drill day wise
    const [drill, setDrill] = useState({
        perPage: 10,
        page: 1,
        date: '',
        projectId: '',
        generateBy: ''
    });

    useEffect(() => {
        dispatch(globalLoadingAction(true));
        dispatch(generatedReportDetails(page, perPage, props.history));
        dispatch(getSummaryConfigData(props.history));
        //dispatch(getSystemUserConfigData(3, props.systemAdmin, props.history));
        dispatch(getLeaveTypeData(props.history));
        dispatch(getOwnLeaveCalenderListData(props.userId, '', props.history));
    }, []);


    useEffect(() => {
        setMultipleLegends(props.multipleLegends ?? []);
    }, [props.multipleLegends]);


    const handleCartPageClick = (data) => {
        dispatch(generatedReportDetails(data.selected + 1, perPage, props.history));
        setPage(data.selected + 1);
    }

    const onSubmitMessageHandler = () => {
        setMessage("");
        setLoading(true);
        dispatch(addNoteData(projectId, message, AddNotData, props.history));
    }

    const AddNotData = (data) => {
        setNoteData(data);
        setLoading(false);
    }

    const onGetNoteHandler = (task_id) => {
        setProjectId(task_id);
        dispatch(globalLoadingAction(true));
        dispatch(getNoteData(task_id, setNotData, props.history));
    }

    const setNotData = (data) => {
        dispatch(globalLoadingAction(false));
        setNoteData(data);
        setIsNote(true);
    }

    const closeHandler = () => {
        setIsNote(false);
        setNoteData([]);
    }

    const onViewHalder = (item) => {
        if (item) {
            let array = JSON.parse(item.report_data);
            if (item.track_type == 0) {
                let array2 = JSON.parse(item.non_billable_report_data);
                setCardNonList(array2);
                //format
                const output = convertProjectsToFormat(array2) ?? null;
                setCardNonDetails(output);
            }
            setCalenderDate(new Date(moment(item.start_date).toDate()));
            setReportId(item._id);
            setStatus(item.status);

            setCardList(array);
            //format
            const output = convertProjectsToFormat(array) ?? null;
            setCardDetails(output);
            setDetails(item);
            setReportType(item.track_type);
            setWeeklyOff(item.weekly_off);
            setCaptureType('0');
            setUserId(item?.generate_by);
            setIsEdit(false)
            // dispatch(getMultiplePeportProgressData(item._id, progressCallBack, props.history));
            dispatch(getPeportProgressData(item._id, progressCallBack, props.history));
        }
    }

    function convertProjectsToFormat(projects) {
        if (!projects.length) return null;

        // pick the time_table from first project's first week
        const timeTable = projects[0].report_data[0].weeks_table[0].time_table;

        let weeksTable = [];
        let totalLeave = 0;
        let totalHour = 0;
        let empRate = 0; // can be overridden if multiple projects differ

        projects.forEach(project => {
            project.report_data.forEach(report => {
                empRate = report.emp_rate; // if multiple, last one will apply
                totalLeave += report.total_leave;
                totalHour += parseFloat(report.total_hour);

                report.weeks_table.forEach(week => {
                    week.data_table.forEach(task => {
                        weeksTable.push({
                            id: task.id,
                            project_id: project.project_id,
                            client_id: project.client_id,
                            project_name: project.project_name,
                            project_unique_id: project.project_unique_id,
                            activity_id: task.activity_id,
                            task_id: task.task_id,
                            total_hour: task.total_hour,
                            time_details: task.time_details
                        });
                    });
                });
            });
        });

        const totalPay = (totalHour * empRate).toFixed(2);

        return {
            time_table: timeTable,
            weeks_table: weeksTable,
            total_leave: totalLeave,
            total_hour: totalHour.toFixed(2),
            total_pay: totalPay,
            emp_rate: empRate
        };
    }

    function transformData(input) {
        if (input === null) return null;
        // const { time_table, weeks_table, emp_rate } = input;
        const { time_table = [], weeks_table = [], emp_rate = 0 } = input;

        return weeks_table && weeks_table.map((project, index) => {
            const rate = emp_rate;

            // single week's table structure
            const week = {
                time_table,
                data_table: [
                    {
                        id: project.id,
                        task_id: project.task_id,
                        activity_id: project.activity_id,
                        project_id: project.project_unique_id,
                        total_hour: project.total_hour,
                        time_details: project.time_details
                    }
                ],
                total_hour: Number(project.total_hour),
                total_pay: (Number(project.total_hour) * rate).toFixed(2)
            };

            return {
                project_id: project.project_id,
                client_id: project.client_id,
                project_name: project.project_name,
                project_unique_id: project.project_unique_id,
                report_data: [
                    {
                        emp_rate: rate,
                        weeks_table: [week],
                        total_leave: input.total_leave,
                        total_hour: project.total_hour,
                        total_pay: week.total_pay
                    }
                ]
            };
        });
    }


    const updateCallBack = () => {
        setReportId(null)
        setStatus(null);
        setAddModal(false);
        setLoading(false);
        setCardList([]);
        setCardDetails(null)
        setIsSave(false);
    }

    const progressCallBack = () => {
        setAddModal(true);
    }

    const onUpdateHandler = async () => {
        setLoading(true);
        let output = transformData(cardDetails) ?? cardList;
        // await dispatch(updateReportDetails(reportId, cardList, updateCallBack, props.history));
        await dispatch(updateReportDetails(reportId, output, updateCallBack, props.history));
        await dispatch(updateReportLeaveListData(userId, personalDetails, updateReportLeaveLisCallBack, props.history));
    }

    const updateReportLeaveLisCallBack = () => {
        setPersonalDetails([]);
    }

    const formatToHHMM = (decimalHour) => {
        if (!decimalHour || isNaN(decimalHour)) return "0:00";
        const hours = Math.floor(decimalHour);
        const minutes = Math.round((decimalHour - hours) * 60);
        return `${hours}:${minutes.toString().padStart(2, '0')}`;
    };

    const onChangeHandler = (index, value, superParentIndex, parentIndex, childIndex) => {
        const updatedData = [...cardList];

        // Store raw input (decimal hour like "1.25")
        updatedData[index].report_data[0].weeks_table[superParentIndex]
            .data_table[parentIndex]
            .time_details[childIndex]
            .working_hour = value;

        const timeDetails = updatedData[index].report_data[0].weeks_table[superParentIndex].data_table[parentIndex].time_details;

        // ✅ Total hours using decimal values
        let totalRowHours = 0;
        timeDetails.forEach(item => {
            const time = parseFloat(item.working_hour);
            if (!isNaN(time)) totalRowHours += time;
        });

        updatedData[index].report_data[0].weeks_table[superParentIndex].data_table[parentIndex].total_hour = totalRowHours.toFixed(2);

        // ✅ Overall total
        let overallTotalHours = 0;
        updatedData[index].report_data[0].weeks_table.forEach(week => {
            week.data_table.forEach(row => {
                const hr = parseFloat(row.total_hour || 0);
                overallTotalHours += !isNaN(hr) ? hr : 0;
            });
        });

        updatedData[index].report_data[0].total_hour = overallTotalHours.toFixed(2);
        updatedData[index].report_data[0].total_hour_hhmm = formatToHHMM(overallTotalHours);

        const empRate = parseFloat(updatedData[index].report_data[0].emp_rate || 0);
        updatedData[index].report_data[0].total_pay = (empRate * overallTotalHours).toFixed(2);

        setCardList(updatedData);
        setIsSave(true);
    };

    const onChangeReportHandler = (value, parentIndex, childIndex) => {
        // deep clone to avoid mutating React state directly
        const updatedData = JSON.parse(JSON.stringify(cardDetails));

        // 1. Update the input value at row/day
        if (updatedData.weeks_table?.[parentIndex]?.time_details?.[childIndex]) {
            updatedData.weeks_table[parentIndex].time_details[childIndex].working_hour = value;
        }

        // 2. Recalculate row total (sum of time_details)
        let totalRowHours = 0;
        updatedData.weeks_table[parentIndex].time_details.forEach(item => {
            const time = parseFloat(item.working_hour);
            if (!isNaN(time)) totalRowHours += time;
        });
        updatedData.weeks_table[parentIndex].total_hour = totalRowHours.toFixed(2);

        // 3. Recalculate overall total (sum of all rows)
        let overallTotalHours = 0;
        updatedData.weeks_table.forEach(row => {
            const hr = parseFloat(row.total_hour || 0);
            if (!isNaN(hr)) overallTotalHours += hr;
        });
        updatedData.total_hour = overallTotalHours.toFixed(2);

        // 4. Convert overall to HH:MM (if you want)
        updatedData.total_hour_hhmm = formatToHHMM(overallTotalHours);

        // 5. Calculate pay
        const empRate = parseFloat(updatedData.emp_rate || 0);
        updatedData.total_pay = (empRate * overallTotalHours).toFixed(2);

        // 6. Update state
        setCardDetails(updatedData);
        setIsSave(true);
    };


    const onChangeRateHandler = (index, value) => {
        const updatedData = [...cardList];
        const rate = value ? parseInt(value) : 0;
        updatedData[index].emp_rate = rate;
        const overallTotalPay = updatedData[index].total_hour * (updatedData[index].emp_rate || 0);
        updatedData[index].total_pay = overallTotalPay;
        setCardList(updatedData);
    }

    const handleTabSelect = (key) => {
        setActiveTab(Number(key));
    };

    const onEditCardHandler = (val, index) => {
        setIsEditIndex(index);
        setIsEdit(val);
    }

    const tabData = [
        {
            id: 1,
            name: "Billable",
            content: <ReportGenerateTimeCard
                changeHandler={(value, parentIndex, childIndex) => onChangeReportHandler(value, parentIndex, childIndex)}
                note={false}
                isEdit={status == 0 ? true : false}
                isEditShow={isEdit}
                editHandler={(val) => onEditCardHandler(val)}
                isConfig={weeklyOff}
                isSummary={props.isSummary}
                isLink={true}
                summaryHandler={(projectId) => onSummaryHandler(projectId)}
                getTimeDetails={(timeIndex, task_id) => onReportTimeDetails(timeIndex, task_id, 0)}
                reportId={reportId}
                details={cardDetails} />,
        },
        {
            id: 2,
            name: "Non-billable",
            content: <ReportGenerateTimeCard
                changeHandler={(value, parentIndex, childIndex) => onChangeReportHandler(value, parentIndex, childIndex)}
                note={false}
                isEdit={status == 0 ? true : false}
                isEditShow={isEdit}
                editHandler={(val) => onEditCardHandler(val)}
                isConfig={weeklyOff}
                isSummary={props.isSummary}
                isLink={true}
                summaryHandler={(projectId) => onSummaryHandler(projectId)}
                getTimeDetails={(timeIndex, task_id) => onReportTimeDetails(timeIndex, task_id, 1)}
                reportId={reportId}
                details={cardNonDetails} />,
        }
    ];

    // const tabData = [
    //     {
    //         id: 1,
    //         name: "Billable",
    //         content: <>{cardList.map((item, index) => {
    //             return (
    //                 <>
    //                     {multipleLegends.map((progress, jndex) => {
    //                         if (progress.project_id == item.project_id) {
    //                             return (
    //                                 <div key={`legend-${index}-${jndex}`}>
    //                                     <MultiProgressReport
    //                                         legends={progress.legends}
    //                                         step={progress.step - 2}
    //                                     />
    //                                 </div>
    //                             );
    //                         }
    //                         return null;
    //                     })}
    //                     <GenerateTimeCard
    //                         key={index}
    //                         changeHandler={(value, superParentIndex, parentIndex, childIndex) => onChangeHandler(index, value, superParentIndex, parentIndex, childIndex)}
    //                         // changeRateHandler={() => { }}
    //                         note={false}
    //                         isEdit={status == 0 ? true : false}
    //                         isEditShow={isEditIndex == index ? isEdit : false}
    //                         editHandler={(val) => onEditCardHandler(val, index)}
    //                         isConfig={weeklyOff}
    //                         isLink={true}
    //                         projectName={item?.project_name}
    //                         getTimeDetails={(weeksIndex, timeIndex, task_id) => onTimeDetails(task_id, index, weeksIndex, timeIndex, 0)}
    //                         details={item?.report_data[0]} /></>
    //             )
    //         })}</>,
    //     },
    //     {
    //         id: 2,
    //         name: "Non-billable",
    //         content: <>{cardNonList.map((item, index) => {
    //             return (
    //                 <>
    //                     {multipleLegends.map((progress, jndex) => {
    //                         if (progress.project_id == item.project_id) {
    //                             return (
    //                                 <div key={`legend-${index}-${jndex}`}>
    //                                     <MultiProgressReport
    //                                         legends={progress.legends}
    //                                         step={progress.step - 2}
    //                                     />
    //                                 </div>
    //                             );
    //                         }
    //                         return null;
    //                     })}

    //                     <GenerateTimeCard
    //                         key={index}
    //                         changeHandler={(value, superParentIndex, parentIndex, childIndex) => onChangeHandler(index, value, superParentIndex, parentIndex, childIndex)}
    //                         // changeRateHandler={() => { }}
    //                         note={false}
    //                         isEdit={status == 0 ? true : false}
    //                         isEditShow={isEditIndex == index ? isEdit : false}
    //                         editHandler={(val) => onEditCardHandler(val, index)}
    //                         isConfig={weeklyOff}
    //                         isLink={true}
    //                         projectName={item?.project_name}
    //                         getTimeDetails={(weeksIndex, timeIndex, task_id) => onTimeDetails(task_id, index, weeksIndex, timeIndex, 1)}
    //                         details={item?.report_data[0]} /></>
    //             )
    //         })}</>,
    //     }
    // ];

    // const onSummaryHandler = (id) => {
    //     history.push(`/view-summary/${id}/${reportId}`);
    // };

    const onSummaryHandler = (id) => {
        const url = `${window.location.origin}/view-summary/${id}/${reportId}`;
        window.open(url, '_blank');
    };

    const onReportTimeDetails = (timeIndex, task_id, type) => {

        let date;
        if (type == 1) {
            date = cardNonDetails.time_table[timeIndex].date; // Example: "Jan 1"
        } else {
            date = cardDetails.time_table[timeIndex].date; // Example: "Jan 1"
        }
        let startDate = details.start_date; // "2024-12-02"
        let endDate = details.end_date; // "2025-01-01"

        // Extract years
        let startYear = startDate.split("-")[0]; // "2024"
        let endYear = endDate.split("-")[0]; // "2025"

        // Extract start month
        let startMonth = startDate.split("-")[1]; // "12" (December)
        // Month mapping
        const monthMap = {
            "Jan": "01",
            "Feb": "02",
            "Mar": "03",
            "Apr": "04",
            "May": "05",
            "Jun": "06",
            "Jul": "07",
            "Aug": "08",
            "Sep": "09",
            "Oct": "10",
            "Nov": "11",
            "Dec": "12",
        };


        let [monthAbbr, day] = date.split(" ");

        let month = monthMap[monthAbbr];
        day = day.padStart(2, "0");
        let year = (month < startMonth) ? endYear : startYear;
        let output = `${year}-${month}-${day}`;
        dispatch(getreportDrillData(task_id, details.generate_by, output, 1, drill.perPage, trackCallBack, props.history));
        setDrill({ ...drill, date: output, projectId: task_id, generateBy: details.generate_by, page: 1 });
    };

    const onTimeDetails = (task_id, index, weeksIndex, timeIndex, type) => {
        let date;
        if (type == 1) {
            date = cardNonList[index].weeks_table[weeksIndex].time_table[timeIndex].date; // Example: "Jan 1"
        } else {
            date = cardList[index].weeks_table[weeksIndex].time_table[timeIndex].date; // Example: "Jan 1"
        }
        let startDate = details.start_date; // "2024-12-02"
        let endDate = details.end_date; // "2025-01-01"

        // Extract years
        let startYear = startDate.split("-")[0]; // "2024"
        let endYear = endDate.split("-")[0]; // "2025"

        // Extract start month
        let startMonth = startDate.split("-")[1]; // "12" (December)
        // Month mapping
        const monthMap = {
            "Jan": "01",
            "Feb": "02",
            "Mar": "03",
            "Apr": "04",
            "May": "05",
            "Jun": "06",
            "Jul": "07",
            "Aug": "08",
            "Sep": "09",
            "Oct": "10",
            "Nov": "11",
            "Dec": "12",
        };

        // Split "Jan 1" into month and day
        let [monthAbbr, day] = date.split(" ");

        let month = monthMap[monthAbbr]; // Convert "Jan" -> "01"

        // Ensure day is always two digits (e.g., "01" instead of "1")
        day = day.padStart(2, "0");

        // Determine the correct year
        //let year = (month === "01") ? endYear : startYear; // Jan -> endYear, Dec -> startYear
        // Determine the correct year
        let year = (month < startMonth) ? endYear : startYear;
        // Construct final date string
        let output = `${year}-${month}-${day}`;
        dispatch(getreportDrillData(task_id, details.generate_by, output, 1, drill.perPage, trackCallBack, props.history));
        setDrill({ ...drill, date: output, projectId: task_id, generateBy: details.generate_by, page: 1 });
    };

    const trackCallBack = () => {
        setTimeModal(true);
    }

    const handlePageClick = (data) => {
        dispatch(getreportDrillData(drill.projectId, drill.generateBy, drill.date, data.selected + 1, drill.perPage, {}, props.history));
        setDrill({ ...drill, page: data.selected + 1 });
    };

    const onReportHandler = async () => {
        setAppLoading(true);
        let output = transformData(cardDetails) ?? cardList;
        let output2 = transformData(cardNonDetails) ?? cardNonList;
        await dispatch(postReportClientApprovalData(details?.project_table_id, 0, '', '', '', '', details?.bill_id, '', reportType, output, output2, sendCallBack, props.history));
        // await dispatch(postReportClientApprovalData(details?.project_table_id, 0, '', '', '', '', details?.bill_id, '', reportType, cardList, cardNonList, sendCallBack, props.history));
        await dispatch(updateReportLeaveListData(userId, personalDetails, updateReportLeaveLisCallBack, props.history));
    }

    const sendCallBack = () => {
        setAddModal(false);
        dispatch(generatedReportDetails(page, perPage, props.history));
        setAppLoading(false);
    }

    const onTextCommantdHandler = (value) => {
        setIsText(true);
        setItemDetails(value);
    }

    const onDeleteHandler = (id) => {

        swal({
            title: "Are you sure?",
            text:
                "You want to remove this item !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(globalLoadingAction(true));
                dispatch(postReportRemoveData(id, deleteCallBack));
            }
        })
    }

    const deleteCallBack = () => {
        dispatch(generatedReportDetails(page, perPage, props.history));
    }

    const onFilterGeneratedReport = (val) => {
        setCaptureType(val);
        setReportFilterLoading(true);
        dispatch(getFilterGeneratedReportData(reportId, parseInt(val), filterDataCallBack, props.history));
    }

    const filterDataCallBack = (item) => {
        setReportFilterLoading(false);
        if (reportType == 0) {
            setCardNonList(item?.data?.non_billable_report_data);
            setCardList(item?.data?.report_data);
        } else {
            setCardList(item?.data);
        }

        setWeeklyOff(item.weekly_off);
    }

    const onManualSubmitHandler = (data) => {
        dispatch(globalLoadingAction(false));
        dispatch(
            addTimesheetManuallyReportData(
                data.project,
                data.activity,
                data.task,
                moment(data.startDate).format("YYYY-MM-DD H:mm:ss"),
                moment(data.endDate).format("YYYY-MM-DD H:mm:ss"),
                data.description,
                props.systemAdmin,
                manualCallBack,
                props.history
            )
        );
    }
    const manualCallBack = () => {
        setManualModal(false);
        setReportFilterLoading(true);
        dispatch(getFilterGeneratedReportData(reportId, parseInt(captureType), filterDataCallBack, props.history));
    }

    const leaveCardProps = useMemo(() => {

        const getTotalHour = (element) =>
            Number(element?.report_data?.[0]?.total_hour) || 0;

        // const billedTotal = cardList.reduce((sum, el) => sum + getTotalHour(el), 0);
        const billedTotal = (Array.isArray(cardList) && cardList.length > 0)
            ? cardList.reduce((sum, el) => sum + getTotalHour(el), 0)
            : 0;
        // const unbilledTotal = cardNonList.reduce((sum, el) => sum + getTotalHour(el), 0);
        const unbilledTotal = (Array.isArray(cardNonList) && cardNonList.length > 0)
            ? cardNonList.reduce((sum, el) => sum + getTotalHour(el), 0)
            : 0;
        const cardTotal = cardList.reduce((sum, el) => sum + getTotalHour(el), 0);


        const totalHour = details?.track_type == 0
            ? (activeTab == 1 ? billedTotal : unbilledTotal)
            : cardTotal;

        return {
            userId: details?.generate_by,
            filterType: 3,
            startDate: details?.start_date,
            endDate: details?.end_date,
            isAddLeave: false,
            isEditLeave: status == 0 ? true : false,
            grandHour: Number(totalHour) ?? 0,
        };
    }, [details, cardNonList, cardList, activeTab]);

    const onPersonalDetails = (item) => {
        if (!details?.start_date) return;

        const [year, month] = details.start_date.split('-');
        const result = [];

        item.data?.forEach((element) => {
            const hourDetails = item.headers?.map((header, index) => {
                const day = header.split(' ')[1]?.padStart(2, '0') || '01';

                return {
                    date: `${year}-${month.padStart(2, '0')}-${day}`,
                    leave_hours: Number(element.values?.[index]) || 0
                };
            });

            result.push({
                leave_type: element.type_id || '',
                hour_details: hourDetails
            });
        });
        setPersonalDetails(result)
        //let obj ={company_id:'',user_id:'',personal_details:result}

        //console.log('hello world...', obj);
    };




    return (
        <>
            <div className="row">
                <div className="breadcrumb-container">
                    <ul>
                        <li>
                            <Link to={"#"}>Reporting</Link>
                        </li>
                        <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"#"}>Generated Report</Link>
                        </li>
                    </ul>
                </div>

                <div className="title-body-container">
                    <div className="title-body mb-3">
                        <h3>Generated Report</h3>
                    </div>


                </div>

                <div className="account-setting-content">
                    <Col lg={12}>
                        <Card className='m-0'>
                            <Card.Body>
                                {props.screenVisible ?
                                    <>
                                        {props.timeCardDetails.length > 0 ?
                                            <>
                                                <Table responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <strong>ID</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Report Type</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Period End Date</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Status</strong>
                                                            </th>

                                                            <th>
                                                                <strong>Actions</strong>
                                                            </th>

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            props.timeCardDetails.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{item.bill_id}</td>
                                                                        <td>
                                                                            {(() => {
                                                                                switch (item.track_type) {
                                                                                    case 1:
                                                                                        return "Billable"
                                                                                    case 2:
                                                                                        return "Non-billable"
                                                                                    default:
                                                                                        return "All"
                                                                                }
                                                                            })()}
                                                                        </td>
                                                                        <td><Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td>
                                                                        {/* <td><Moment format="D MMM YYYY" withTitle>{item.start_date}</Moment> to <Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td> */}
                                                                        {/* <td>
                                                                            <button
                                                                                type="button"
                                                                                disabled={item.send_back_msg ? false : true}
                                                                                onClick={() => onTextCommantdHandler(item.send_back_msg)}
                                                                                className="btn btn-info btn-xs sharp btn-black"
                                                                            >
                                                                                <i className="fa fa-commenting" aria-hidden="true"></i>
                                                                            </button>

                                                                        </td> */}
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                {(() => {
                                                                                    switch (item.status) {
                                                                                        case 0:
                                                                                            return (
                                                                                                <p class="text-muted fw-bold">New</p>
                                                                                            );
                                                                                        case 1:
                                                                                            return (
                                                                                                <p class="text-muted fw-bold">Submitted</p>
                                                                                            );
                                                                                        case 2:
                                                                                            return (
                                                                                                <p class="text-secondary fw-bold">Under process</p>
                                                                                            );
                                                                                        default:
                                                                                            return (
                                                                                                <p class="text-success fw-bold">Approved</p>
                                                                                            );
                                                                                    }
                                                                                })()}
                                                                            </div>

                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    onClick={() => onViewHalder(item)}
                                                                                    className="btn btn-info shadow btn-xs"
                                                                                >Details
                                                                                </button>
                                                                                {item.status == 0 ?
                                                                                    <button
                                                                                        onClick={() => onDeleteHandler(item._id)}
                                                                                        className="btn btn-danger shadow btn-xs ms-2"
                                                                                    >Delete
                                                                                    </button> : null}
                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                );
                                                            })
                                                        }
                                                    </tbody>
                                                </Table>
                                            </>
                                            :
                                            <div className="nodata-found-view">
                                                <i class="fa fa-search" aria-hidden="true"></i>
                                                <h2>Data not found</h2>
                                                <p>Report data is empty or Try again search</p>
                                                <button type="button"
                                                //onClick={onCleanHandler}
                                                >
                                                    Retry
                                                </button>
                                            </div>
                                        }
                                        <div className="pagination-container">
                                            {parseInt(props.totalRecord) > 0 && props.showLoading == false ? (
                                                <div className="page-result alignResult">
                                                    <p>Showing{" "}{(page - 1) * perPage + 1 + " - " + ((page - 1) * perPage + props.timeCardDetails.length) + " of " + "( " + props.totalRecord + " items )"}</p>
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}

                                            {parseInt(props.totalRecord) > perPage ? (
                                                <ReactPaginate
                                                    containerClassName="pagination-gutter false pagination-circle pagination"
                                                    pageClassName="page-item"
                                                    pageLinkClassName="page-link"
                                                    breakLabel="..."
                                                    nextLabel={<i class="fa fa-angle-right" aria-hidden="true"></i>}
                                                    nextClassName="page-item"
                                                    nextLinkClassName="page-link"
                                                    previousLabel={<i class="fa fa-angle-left" aria-hidden="true"></i>}
                                                    previousClassName="page-item"
                                                    previousLinkClassName="page-link"
                                                    breakClassName="page-item"
                                                    breakLinkClassName="page-link"
                                                    renderOnZeroPageCount={null}
                                                    activeClassName="active"
                                                    onPageChange={handleCartPageClick}
                                                    pageRangeDisplayed={3}
                                                    pageCount={props.totalPage}
                                                    //initialPage={active - 1}
                                                    forcePage={page - 1}
                                                />
                                            ) : null}
                                        </div>
                                    </>
                                    : null}

                            </Card.Body>
                        </Card>
                        <div>
                            <p><strong>Note:</strong> Use increments of 0.25 (15 minutes) when recording hours.</p>
                        </div>
                    </Col>
                </div>
            </div>

            <Modal
                className="fade bd-example-modal-sm"
                size="xl"
                show={addModal}
                onHide={() => { isSave ? setSaveModal(true) : setAddModal(false) }}
                centered
            >
                {reportFilterLoading ?
                    <div className='report-loder-container'>
                        <div className='report-loder'>
                            <Spinner
                                as="span"
                                animation="border"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                                variant="success"
                            /></div>
                    </div> : null}
                <Modal.Header closeButton>
                    <Modal.Title><h2>Time Report</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {cardList.length > 0 ?
                        <>
                            <div className="card-detail-header">

                                <div className="card-detail-left">
                                    <div>
                                        <h4 className='mb-2'><strong>ID:</strong> {details?.bill_id}</h4>
                                    </div>
                                    <div>
                                        <h4 className='mb-2'><strong>Person Name:</strong> {details?.employee_first_name} {details?.employee_last_name}</h4>
                                    </div>
                                    <div>
                                        <h4 className='mb-2'><strong>Period End Date:</strong> <Moment format="D MMM YYYY" withTitle>{details?.end_date}</Moment></h4>
                                    </div>
                                </div>

                            </div>


                            {reportType == 0 ?
                                <div className='report-tabview'>
                                    <Tab.Container
                                        defaultActiveKey={activeTab}
                                        onSelect={handleTabSelect}
                                    >
                                        <div className='tab-filter-container'>
                                            <Nav as="ul" className="nav-pills mb-4 light">
                                                {tabData.map((data, i) => (
                                                    <Nav.Item as="li" key={i}>
                                                        <Nav.Link eventKey={data.id}>
                                                            {data.name}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                ))}
                                            </Nav>
                                            <div className='report-filter-manual-container'>
                                                <div className="form-group card-filter-select">
                                                    <div className="select-drop-down">
                                                        <span><i class="fa fa-angle-down"></i></span>
                                                        <select
                                                            defaultValue={"option"}
                                                            className="form-control select-control"
                                                            value={captureType}
                                                            onChange={(e) => onFilterGeneratedReport(e.target.value)}
                                                        >
                                                            <option value="0">All</option>
                                                            <option value="1">Real time</option>
                                                            <option value="2">Manual</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {status == 0 ?
                                                    <button
                                                        className="add-manual-report-btn ms-2"
                                                        onClick={() => setManualModal(true)}
                                                    >Add Manual Entry</button> : null}
                                            </div>
                                        </div>
                                        <Tab.Content className="">
                                            {tabData.map((data, i) => (
                                                <Tab.Pane
                                                    eventKey={data.id}
                                                    key={i}
                                                >
                                                    {activeTab === data.id && data.content}
                                                </Tab.Pane>
                                            ))}
                                        </Tab.Content>
                                    </Tab.Container>
                                </div> :
                                <>
                                    <div className='tab-filter-container mt-4 mb-3'>
                                        <div></div>
                                        <div className="form-group card-filter-select">
                                            <div className="select-drop-down">
                                                <span><i class="fa fa-angle-down"></i></span>
                                                <select
                                                    defaultValue={"option"}
                                                    className="form-control select-control"
                                                    value={captureType}
                                                    onChange={(e) => onFilterGeneratedReport(e.target.value)}
                                                >
                                                    <option value="0">All</option>
                                                    <option value="1">Real time</option>
                                                    <option value="2">Manual</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {cardList.map((item, index) => {
                                        return (
                                            <>
                                                {/* {multipleLegends.map((progress, jndex) => {
                                                    if (progress.project_id == item.project_id) {
                                                        return (
                                                            <div key={`legend-${index}-${jndex}`}>
                                                                <MultiProgressReport
                                                                    legends={progress.legends}
                                                                    step={progress.step - 2}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })} */}
                                                <GenerateTimeCard
                                                    key={index}
                                                    changeHandler={(value, superParentIndex, parentIndex, childIndex) => onChangeHandler(index, value, superParentIndex, parentIndex, childIndex)}
                                                    // changeRateHandler={(value) => onChangeRateHandler(index, value)}
                                                    note={false}
                                                    isEdit={status == 0 ? true : false}
                                                    isConfig={weeklyOff}
                                                    isLink={true}
                                                    projectName={item?.project_name}
                                                    getTimeDetails={(weeksIndex, timeIndex, task_id) => onTimeDetails(task_id, index, weeksIndex, timeIndex, 0)}
                                                    details={item?.report_data[0]} /></>
                                        )
                                    })} </>}

                            <div style={{ marginTop: 20 }}>
                                <LeaveCardView
                                    generateReport={() => { dispatch(getLeaveTypeData(props.history)) }}
                                    changeReport={(val) => onPersonalDetails(val)}
                                    {...leaveCardProps} />
                            </div>

                            {status == 0 ? null :
                                <div>
                                    <ProgressReport legends={props.legends} step={props.stepCount - 1} />
                                </div>}
                        </>
                        :
                        <div className='text-center mt-3'><h3>No Data Found</h3></div>}
                </Modal.Body>
                <Modal.Footer>
                    {status == 0 ?
                        <>
                            <button
                                className='save-submit-btn'
                                onClick={() => isSave ? setSaveModal(true) : onReportHandler()}
                            >
                                Save & Submit {" "}
                                {appLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : null}
                            </button>
                            <button
                                className='save-submit-btn'
                                onClick={() => onUpdateHandler()}>
                                Save {" "}
                                {loading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : null}
                            </button>
                        </>
                        : null}
                    <button className='close-btn' onClick={() => { isSave ? setSaveModal(true) : setAddModal(false) }}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={saveModal}
                centered
            >
                <div className='expired-subcription-plan'>
                    <h3>Hey you are skipping the present report without saving it.</h3>
                    <button type="button"
                        onClick={() => setSaveModal(false)}
                        className="subscription-plan-btn">
                        Close
                    </button>

                </div>
            </Modal>

            <Modal
                className="fade bd-example-modal-sm"
                size="xl"
                show={timeModal}
                onHide={() => setTimeModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h2>Time Track Details</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.drillList.length > 0 ?
                        <>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            <strong>Client Name</strong>
                                        </th>
                                        <th>
                                            <strong>Employee Name</strong>
                                        </th>
                                        <th>
                                            <strong>Activity</strong>
                                        </th>
                                        <th>
                                            <strong>Task</strong>
                                        </th>
                                        <th>
                                            <strong>Duration</strong>
                                        </th>
                                        <th><strong>Date</strong></th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        props.drillList.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.client_first_name} {item.client_last_name}</td>
                                                    <td>{item.user_first_name} {item.user_last_name}</td>
                                                    <td>{item.activity}</td>
                                                    <td>{item.task}</td>
                                                    <td>{item.time_difference}</td>
                                                    <td><Moment format="D MMM YYYY" withTitle>{item.start_time}</Moment> to <Moment format="D MMM YYYY" withTitle>{item.end_time}</Moment></td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </Table>
                        </>
                        :
                        <div className="nodata-found-view">
                            <h2>Data not found</h2>
                            <p>Report data is empty or Try again search</p>
                            <button type="button"
                            //onClick={onCleanHandler}
                            >
                                Retry
                            </button>
                        </div>
                    }
                    <div className="pagination-container">
                        {parseInt(props.drillTotalRecord) > 0 && props.showLoading == false ? (
                            <div className="page-result alignResult">
                                <p>Showing{" "}{(drill.page - 1) * drill.perPage + 1 + " - " + ((drill.page - 1) * drill.perPage + props.drillList.length) + " of " + "( " + props.drillTotalRecord + " items )"}</p>
                            </div>
                        ) : (
                            <div></div>
                        )}

                        {parseInt(props.drillTotalRecord) > drill.perPage ? (
                            <ReactPaginate
                                containerClassName="pagination-gutter false pagination-circle pagination"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                breakLabel="..."
                                nextLabel={<i class="fa fa-angle-right" aria-hidden="true"></i>}
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                previousLabel={<i class="fa fa-angle-left" aria-hidden="true"></i>}
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                renderOnZeroPageCount={null}
                                activeClassName="active"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={3}
                                pageCount={props.drillTotalPage}
                                //initialPage={active - 1}
                                forcePage={drill.page - 1}
                            />
                        ) : null}
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <button className='close-btn' onClick={() => setTimeModal(false)}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>

            <AddReportManual
                show={manualModal}
                data={{ project: details?.project_table_id }}
                action={1}
                submitHandler={(data) => onManualSubmitHandler(data)}
                closeHandler={() => setManualModal(false)}
            />
            <RightSideModal
                showModal={isComment}
                userId={userId}
                setShowModal={() => setIsComment(false)}
            />
            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={isText}
                onHide={() => setIsText(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h4>Comment</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <h5>{itemDetails}</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsText(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>

    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.timeCard.screenVisible,
        showLoading: state.clients.showLoading,
        clientList: state.clients.clientList,
        projectList: state.project.projectList,
        activitiesList: state.project.activitiesList,
        taskList: state.project.taskList,
        countryList: state.country.countryList,
        timeCardDetails: state.timeCard.generatedDetails,
        totalPage: state.timeCard.totalPage,
        totalRecord: state.timeCard.totalRecord,
        configDetails: state.systemconfig.weekConfig,
        systemAdmin: state.auth.systemAdmin,
        projectDetails: state.project.projectDetails,
        userId: state.auth.userId,
        employeeList: state.employee.projectEmployeeList,
        drillList: state.timeCard.drillList,
        drillTotalPage: state.timeCard.drillTotalPage,
        drillTotalRecord: state.timeCard.drillTotalRecord,
        stepCount: state.timeCard.stepCount,
        legends: state.timeCard.legends,
        multipleLegends: state.timeCard.multipleLegends,
        isSummary: state.systemconfig.isSummary,
    };
};
export default connect(mapStateToProps)(GeneratedReport);